<template>
  <div>
    <i class="fa fa-check text-success"></i>
    {{ title }}

    <v-button
      style-type="secondary"
      size="xs"
      :text="`word.${showItems ? 'hide' : 'show'}`"
      :rounded="true"
      @click="showItems = !showItems"
    />

    <v-collapse-transition>
      <div class="mt-2 p-0 card bg-dark text-white" v-if="showItems">
        <ul class="m-4">
          <li v-for="title in items" :key="title">
            <small>{{ title }}</small>
          </li>
        </ul>
      </div>
    </v-collapse-transition>
  </div>
</template>

<script>
import Button from '@/common/components/Button.vue';
import { CollapseTransition } from '@ivanv/vue-collapse-transition';

export default {
  name: 'CheckSixCategories',
  components: {
    'v-button': Button,
    'v-collapse-transition': CollapseTransition,
  },
  props: {
    title: {
      type: String,
      default() {
        return 'Je commercial kan winnen in 6 categorieën';
      },
    },
  },
  data() {
    return {
      showItems: false,
      items: [
        'Geloofwaardig',
        'Leuk om naar te kijken',
        'Irritant',
        'Onderscheidend',
        'Aanzetten tot actie',
        'Algemene waardering',
      ],
    };
  },
};
</script>
